<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <a href="https://www.bioxsys.cz/#/onas" target=_new>
              About Us
            </a>
          </li>
          <li>
            <a href="https://www.bioxsys.cz/#/kontaktujte" target=_new>
              Contacts
            </a>
          </li>
          <li>
            <a href="https://www.bioxsys.cz/#/Welcome#novinky" target=_new>
              News
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">
        <h6> &copy; Bioxsys s.r.o., 2019 - 2021. All rights reserved</h6>
        <!-- <i class="fa fa-heart heart"></i> by
        <a href="https://binarcode.com" target="_blank" rel="noopener">BinarCode</a>.
        <span>Designed by <a href="https://www.creative-tim.com/?ref=pdf-vuejs" rel="noopener" target="_blank">Creative Tim</a>.</span> -->
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
